const baseState = {
  clientsFeedbackMap: new Map(),
  employeesFeedbackMap: new Map(),
  hadFetched: false,
}

export const state = () => ({
  ...baseState,
})

function clearFeedbackFromLocalStorage() {
  localStorage.removeItem('jbs:coaching-feedback:clients')
  localStorage.removeItem('jbs:coaching-feedback:employees')
}

function getFeedbacksFromLocalStorage() {
  const clientsFeedbackString = localStorage.getItem(
    'jbs:coaching-feedback:clients'
  )
  const employeesFeedbackString = localStorage.getItem(
    'jbs:coaching-feedback:employees'
  )
  if (!clientsFeedbackString || !employeesFeedbackString)
    return {
      clientsFeedback: null,
      employeesFeedback: null,
    }
  return {
    clientsFeedback: JSON.parse(clientsFeedbackString),
    employeesFeedback: JSON.parse(employeesFeedbackString),
  }
}

function setFeedbacksToLocalStorage(clients = [], employees = []) {
  localStorage.setItem('jbs:coaching-feedback:clients', JSON.stringify(clients))
  localStorage.setItem(
    'jbs:coaching-feedback:employees',
    JSON.stringify(employees)
  )
}

function arrayToMap(list = [], key = '') {
  const map = new Map()
  if (!list.length || !key) return map
  const keys = key.split('.')
  for (const item of list) {
    let keyValue = item
    for (const k of keys) {
      if (keyValue && typeof keyValue === 'object' && k in keyValue) {
        keyValue = keyValue[k]
      } else {
        keyValue = undefined
      }
    }
    map.set(keyValue, { ...item })
  }
  return map
}

export const mutations = {
  UPDATE_ROOT: (state, payload) => Object.assign(state, payload),
  CLEAR: state => {
    clearFeedbackFromLocalStorage()
    Object.assign(state, { ...baseState })
  },
}

export const actions = {
  async fetchCoachingFeedback({ commit, state }) {
    try {
      if (state.hadFetched) return
      const {
        clientsFeedback,
        employeesFeedback,
      } = getFeedbacksFromLocalStorage()
      if (Array.isArray(clientsFeedback) && Array.isArray(employeesFeedback)) {
        commit('UPDATE_ROOT', {
          clientsFeedbackMap: arrayToMap(clientsFeedback, 'client.code'),
          employeesFeedbackMap: arrayToMap(
            employeesFeedback,
            'coachee.employeeCode'
          ),
          hadFetched: true,
        })
        return
      }
      const { data } = await this.$axios.get('/v3/app/coachingFeedback')
      commit('UPDATE_ROOT', {
        clientsFeedbackMap: arrayToMap(data.clientsFeedback, 'client.code'),
        employeesFeedbackMap: arrayToMap(
          data.employeesFeedback,
          'coachee.employeeCode'
        ),
        hadFetched: true,
      })
      setFeedbacksToLocalStorage(data.clientsFeedback, data.employeesFeedback)
    } catch (error) {
      console.error('Error fetching coachings feedbacks', error)
    }
  },
}
